<template>
  <!--==================
    component shows all post created (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <a class="btn btn-primary my-3 ml-3" href="/dashboard/destination/new-post" target="_blank">New Post</a>
    <nav>
      <div class="nav nav-tabs flex-row mb-4" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link active"
          id="nav-published-tab"
          data-toggle="tab"
          href="#nav-published"
          role="tab"
          aria-controls="nav-published"
          aria-selected="true"
          data-selector="published"
        >
          published <span class="badge badge-light font-weight-bold">{{ publishedPosts.length }}</span>
        </a>
        <a
          class="nav-item nav-link"
          id="nav-unpublished-tab"
          data-toggle="tab"
          href="#nav-unpublished"
          role="tab"
          aria-controls="nav-unpublished"
          aria-selected="false"
          data-selector="unpublished"
        >
          unpublished <span class="badge badge-light font-weight-bold">{{ unpublishedPosts.length }}</span>
        </a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <!-- published post -->
      <div class="tab-pane fade show active" id="nav-published" role="tabpanel" aria-labelledby="nav-published-tab">
        <div class="card">
          <div class="table-responsive">
            <table id="table-destination-post" class="table table-sm table-nowrap card-table">
              <tbody>
                <tr
                  v-for="(post, index) in publishedPosts"
                  :key="post.id"
                  :data-position="post.position"
                  :data-id="post.id"
                >
                  <td :id="'row-' + post.id">{{ index + 1 }}</td>
                  <td>
                    <img class="img-destination-list" :src="post.pageImages[0]" />
                  </td>
                  <td class="font-weight-bold">
                    <a class="d-block pb-2" :href="destinationURL + post.slug" target="_blank">{{ post.title }}</a>
                    <span class="small text-muted"
                      ><i class="icofont-clock-time"></i>
                      {{ post.updatedAt | utcDateToLocalDate("yyyy-MM-dd HH:mm:ss") }}</span
                    >
                  </td>
                  <td class="text-right">
                    <div class="dropdown">
                      <button
                        class="btn btn-sm btn-primary ml-2 mr-2"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="icofont-listine-dots"></i>
                      </button>

                      <div class="dropdown-menu">
                        <button class="dropdown-item" @click="viewPost(post.slug)">
                          <i class="icofont-eye-alt"></i> View
                        </button>
                        <button class="dropdown-item" @click="updatePost($event)" :data-id="post.id">
                          <i class="icofont-edit"></i> Edit
                        </button>
                        <button
                          class="dropdown-item"
                          @click="unpublishStatus($event)"
                          :data-id="post.id"
                          :data-index="index"
                        >
                          <i class="icofont-eye-blocked"></i> Unpublish
                        </button>
                        <button
                          class="dropdown-item"
                          @click="deletePost($event)"
                          :data-id="post.id"
                          :data-index="index"
                          data-page="published"
                        >
                          <i class="icofont-bin"></i> Delete
                        </button>
                        <button class="dropdown-item" @click="postDetail($event)" :data-index="index">
                          <i class="icofont-info-circle"></i> Details
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- unpublished post -->
      <div class="tab-pane fade" id="nav-unpublished" role="tabpanel" aria-labelledby="nav-unpublished-tab">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-sm table-nowrap card-table">
              <tbody>
                <tr
                  v-for="(post, index) in unpublishedPosts"
                  :key="post.id"
                  :data-position="post.position"
                  :data-id="post.id"
                >
                  <td :id="'row-' + post.id">{{ index + 1 }}</td>
                  <td>
                    <img class="img-destination-list" :src="post.pageImages[0]" />
                  </td>
                  <td class="font-weight-bold">
                    <a class="d-block pb-2" :href="'#'" target="_blank">{{ post.title }}</a>
                    <span class="small text-muted"
                      ><i class="icofont-clock-time"></i>
                      {{ post.updatedAt | utcDateToLocalDate("yyyy-MM-dd HH:mm:ss") }}</span
                    >
                  </td>
                  <td class="text-right">
                    <button
                      @click="publishStatus($event)"
                      class="btn btn-sm btn-success mr-2"
                      :data-id="post.id"
                      :data-index="index"
                    >
                      Publish
                    </button>
                    <button @click="updatePost($event)" class="btn btn-sm btn-primary ml-2 mr-2" :data-id="post.id">
                      Edit
                    </button>
                    <button
                      @click="deletePost($event)"
                      class="btn btn-sm btn-danger ml-2"
                      :data-id="post.id"
                      :data-index="index"
                      data-page="unpublished"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div
        v-if="publishedPosts.length"
        class="modal fade"
        id="post-detail"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header py-3">
              <h5 class="modal-title">
                <strong>{{ publishedPosts[detailIndex].title }}</strong>
              </h5>
              <button @click="modalClose()" type="button" class="close" aria-label="Close">
                <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
              </button>
            </div>
            <div v-if="detailIndex in publishedPosts" class="modal-body">
              <div class="d-flex col-md-10 mb-4">
                <span class="col-md-3 text-right"><strong>ID :</strong></span>
                <span class="col-md-9">{{ publishedPosts[detailIndex].id }}</span>
              </div>
              <div class="d-flex col-md-10 mb-4">
                <span class="col-md-3 text-right"><strong>Slug :</strong></span>
                <span class="col-md-9">{{ publishedPosts[detailIndex].slug }}</span>
              </div>
              <div class="d-flex col-md-10 mb-4">
                <span class="col-md-3 text-right"><strong>Created at :</strong></span>
                <span class="col-md-9">{{
                  publishedPosts[detailIndex].createdAt | utcDateToLocalDate("yyyy-MM-dd HH:mm:ss")
                }}</span>
              </div>
              <div class="d-flex col-md-10 mb-4">
                <span class="col-md-3 text-right"><strong>Updated at :</strong></span>
                <span class="col-md-9">{{
                  publishedPosts[detailIndex].updatedAt == publishedPosts[detailIndex].createdAt
                    ? "Never"
                    : publishedPosts[detailIndex].updatedAt | utcDateToLocalDate("yyyy-MM-dd HH:mm:ss")
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DestinationPost",

  data() {
    return {
      detailIndex: 0,
      destinationURL: process.env.VUE_APP_DESTINATION_URL,
    };
  },

  computed: {
    ...mapGetters(["publishedDestinationPosts", "unpublishedDestinationPosts"]),

    publishedPosts() {
      return this.publishedDestinationPosts;
    },

    unpublishedPosts() {
      return this.unpublishedDestinationPosts;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchPublishedDestinationPosts();
      await this.fetchUnpublishedDestinationPosts();

      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "hideBarLoading",
      "fetchPublishedDestinationPosts",
      "fetchUnpublishedDestinationPosts",
      "publishDestinationPost",
      "deleteDestinationPost",
    ]),

    postDetail(e) {
      let index = e.target.getAttribute("data-index");
      this.detailIndex = index;

      $("#post-detail").modal("show");
    },

    async publishStatus(e) {
      let id = e.target.getAttribute("data-id");

      await this.publishDestinationPost({ id, publish: true });
      this.fetchPublishedDestinationPosts();
    },

    async unpublishStatus(e) {
      let id = e.target.getAttribute("data-id");

      await this.publishDestinationPost({ id, publish: false });
      this.fetchUnpublishedDestinationPosts();
    },

    deletePost(e) {
      let id = e.target.getAttribute("data-id");
      let page = e.target.getAttribute("data-page");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this post?",
        buttons: {
          confirm: async () => {
            await dP.deleteDestinationPost(id);

            if (page == "unpublished") {
              dP.fetchUnpublishedDestinationPosts();
            } else {
              dP.fetchPublishedDestinationPosts();
            }
          },
          cancel: () => {},
        },
      });
    },

    updatePost(e) {
      let id = e.target.getAttribute("data-id");
      window.open("/dashboard/destination/post/edit/" + id, "_blank");
    },

    viewPost(slug) {
      window.open(process.env.VUE_APP_DESTINATION_URL + slug, "_blank");
    },

    modalClose() {
      $("#post-detail").modal("hide");
    },
  },
};
</script>
